import { CartItemInterface } from '@pylot-data/pylotschema'

export const getItemSubscriptionFrequency = (item: CartItemInterface) => {
    const product = item?.product
    if (!product) {
        return ''
    }
    return item.subscription_data?.billing_period ?? 'NA'
}
